"use client"

import Link from "next/link"
import { Button } from "@quibas/integration-hub-ui/button"
import { DashboardSquare01Icon, RefreshCw } from "@quibas/integration-hub-ui/icons"

import { translate, type Locale } from "@/i18n/locale"
import { ServiceInterruptionIllustration } from "./status-illustrations"
import { SystemStatusView } from "./system-status-view"

/** Takes the locale explicitly: global-error renders outside the root layout's locale provider. */
export function TemporaryErrorScreen({ locale, reset }: { locale: Locale; reset: () => void }) {
  const t = (key: Parameters<typeof translate>[1]) => translate(locale, key)
  return (
    <SystemStatusView
      role="alert"
      illustration={<ServiceInterruptionIllustration className="h-auto w-72 max-w-full sm:w-80" />}
      title={t("Hay aksi! Yolda bir engele takıldık")}
      description={t("Sistemimizde kısa süreli bir kesinti yaşanıyor. Her şeyin kısa süre içinde normale dönmesini bekliyoruz.")}
      actions={<>
        <Button type="button" iconLeft={<RefreshCw aria-hidden="true" />} onClick={reset}>{t("Tekrar dene")}</Button>
        <Button asChild variant="outline">
          <Link href="/"><DashboardSquare01Icon aria-hidden="true" />{t("Genel bakışa dön")}</Link>
        </Button>
      </>}
    />
  )
}
